export enum FeeType {
    Fixed = 'fixed',
    Rate = 'rate'
}
